export default "/_next/static/fonts/142461908bfa6ee83c81c4ecef6d9fe0.ttf";